import { lazyLoad } from './lazyLoad'

export const utils = {
  initialize () {
    console.log('DEBUG (utils) Initializing utils.')

    return {
      lazyLoad: lazyLoad.initialize()
    }
  }
}